<template>
  <div class="application" id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import "./assets/scss/Main.scss";
  @import './assets/fonts/ionicons/scss/ionicons.scss';
  @import './assets/scss/fonts.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue